import { Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'bodyanalytics-login-button',
  templateUrl: './login-button.component.html',
  imports: [MatIconModule, MatButtonModule],
  styles: [
    `
      .abx-nav-text-link {
        appearance: none;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        font-family: inherit;
        font-size: 14px;
        font-weight: 500;
        color: inherit;
        opacity: 0.75;
        text-decoration: none;
        transition:
          opacity 150ms ease-out,
          color 150ms ease-out;
      }
      .abx-nav-text-link:hover {
        opacity: 1;
      }
    `,
  ],
})
export class LoginButtonComponent {
  private router = inject(Router);

  protected loginLink = RouterUrlsEnum.LOGIN;

  protected auth = inject(AuthService);

  login() {
    this.router.navigate([`${this.loginLink}`]);
  }
}
